import type { FunctionComponent } from "react";
import { FileIcon } from "./file-icon";

interface FileTypeIconProps {
  fileType: string;
}

export const FileTypeIcon: FunctionComponent<FileTypeIconProps> = ({ fileType }) => {
  return (
    <div className="flex items-center justify-center text-2xl">
      <FileIcon fileType={fileType} />
    </div>
  );
};
